import React, { useEffect, useState } from 'react';
import { TranslateFunction } from 'react-utilities';
import parentalRequestService from '../services/parentalRequestService';
import useModal from '../../../hooks/useModal';
import parentalRequestConstants from '../constants/parentalRequestConstants';
import parentalRequestInlineErrorHandler from '../utils/parentalRequestErrorHandler';
import ParentalRequestErrorReason from '../enums/ParentalRequestErrorReason';
import { sendLoadRequestBroadcastEvent } from '../services/eventService';
import RequestType from '../enums/RequestType';
import changeBirthdayUtils from '../utils/changeBirthdayUtils';

const ParentalRequestBroadcast = ({
  translate,
  consentType,
  successCallBack,
  onHideCallback,
  value = null
}: {
  translate: TranslateFunction;
  consentType: RequestType;
  successCallBack: (sessionIde: string) => void;
  onHideCallback: () => void;
  value: Record<string, unknown> | null;
}): JSX.Element => {
  const [errorMessage, setErrorMessage] = useState<string>(
    parentalRequestConstants.translationKeys.gatherParentEmail.unknownError
  );
  const { emailSentConfirmation } = parentalRequestConstants.translationKeys;

  const [errorModal, errorModalService] = useModal({
    translate,
    title: translate(parentalRequestConstants.translationKeys.gatherParentEmail.unknownError),
    body: <p>{translate(errorMessage)}</p>,
    actionButtonTranslateKey: emailSentConfirmation.btnText,
    onAction: () => {
      setErrorMessage('');
      errorModalService.close();
      onHideCallback();
    },
    onHide: onHideCallback
  });

  const broadcastHandler = async () => {
    try {
      const response = await parentalRequestService.sendRequestToAllParents({
        requestType: consentType,
        requestDetails: value
      });
      const newBirthdateString = value?.newBirthdate as string;
      const newBirthdate = new Date(newBirthdateString);
      const state = changeBirthdayUtils.getAgeRange(newBirthdate);
      sendLoadRequestBroadcastEvent(RequestType.UpdateBirthdate, state, response.sessionId);
      successCallBack(response.sessionId);
    } catch (e) {
      if (e instanceof Error) {
        const errorReason = parentalRequestInlineErrorHandler(
          e.message as ParentalRequestErrorReason
        );
        setErrorMessage(errorReason);
        errorModalService.open();
      } else {
        errorModalService.open();
      }
    }
  };

  useEffect(() => {
    // eslint-disable-next-line no-void
    void broadcastHandler();
  }, []);
  return <div>{errorModal}</div>;
};

export default ParentalRequestBroadcast;
